import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Grid,
  Fade,
  Backdrop,
  Paper,
  Button,
  Typography,
  Link,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { amxPalette } from "../ThemeProvider";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 200,
    minHeight: 200,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: 20,
    backgroundColor: amxPalette.white.main,
    maxWidth: "70%",
    height: "628px%",
    paddingLeft: 40,
    paddingRight: 40,
  },
  header: {
    paddingTop: 30,
    paddingBottom: 24,
  },
  legalCopy: {
    paddingTop: 20,
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 20,
    backgroundColor: amxPalette.white.main,
    maxHeight: "400px",
    overflow: "auto",
    boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.05)",
  },
  smallPrint: { fontStyle: "italic" },
  button: { marginTop: "20px" },
  footerText: { width: "100%", textAlign: "center" },
}));

export const Disclaimer = ({ disabled, onClosed }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(
    () => !sessionStorage.getItem(Disclaimer.storageKey)
  );
  if (disabled) return null;

  const handleOnAccept = () => {
    sessionStorage.setItem(Disclaimer.storageKey, true);
    setIsOpen(false);
    onClosed();
  };

  return (
    <Modal
      open={isOpen}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      onClosed={onClosed}
    >
      <Fade in={isOpen}>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.header} variant="h2">
                Disclaimers
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.legalCopy}>
              <h2 id="disclaimer-section-a">SECTION A: GENERAL TERMS</h2>
              <p>
                The provisions set out in this Section A are relevant to all
                users of this website i.e. AMXConnect.
              </p>
              <p>
                The site (the “website” or “AMXConnect”) is made available by
                the Asset Management Exchange (“AMX”). The Asset Management
                Exchange and AMX are trading names of Carne Global Fund Managers 
                (Ireland) Limited registered in Ireland (No. 377914). Authorised 
                and regulated by the Central Bank of Ireland, registered with 
                the Securities Exchange Commission as an Exempt Reporting Adviser 
                (CRD 173794); and the Commodity Futures Trading Commission as a Commodity 
                Pool Operator, member of the National Futures Association, Carne 
                International Financial Services (UK) Limited (registered in 
                England, No. 11555138; authorised and regulated by the Financial
                 Conduct Authority No. 823316; Australian ARBN. 648 201 610, and 
                 exempt from the requirement to hold an Australian Financial Services 
                 License under ASIC Class Order [03/1099]), and The Asset
                Management Exchange (IP Co.) Limited (registered in England, No.
                11686713).
              </p>
              <p>
                All content, information and software provided on and through
                the website (“content”) may be used solely under the following
                terms and conditions (“Terms of Use”) and the important notice
                set out here (“Important Notice”).
              </p>
              <p>
                YOUR USE OF THIS WEBSITE CONSTITUTES YOUR ACCEPTANCE OF THESE
                TERMS OF USE AND THE IMPORTANT NOTICE IN A PERSONAL CAPACITY
                AND, WHERE YOU ACCESS AMXCONNECT ON BEHALF OF A SHAREHOLDER OR
                UNITHOLDER IN THE AMX FUNDS, A PORTFOLIO MANAGER IN RESPECT OF
                THE AMX FUNDS, OR OTHER LEGAL ENTITY (THE “COMPANY”), FOR AND ON
                BEHALF OF THE COMPANY. YOU REPRESENT AND WARRANT THAT YOU HAVE
                THE FULL POWER AND AUTHORITY TO BIND THE COMPANY TO THESE TERMS
                OF USE. IF YOU DO NOT AGREE TO THESE TERMS OF USE AND THE
                IMPORTANT NOTICE, YOU SHOULD IMMEDIATELY DISCONTINUE YOUR USE OF
                THIS WEBSITE. WE RECOMMEND YOU PRINT A COPY OF THESE TERMS OF
                USE AND THE IMPORTANT NOTICE FOR YOUR FUTURE REFERENCE.
              </p>
              <p>
                Unless the context requires otherwise, any references to “you”
                below shall be read as references to you and the Company.
              </p>
              <p>1. Website Licence.</p>
              <p>
                As a user of this website, you are granted a non-exclusive,
                non-transferable, revocable, limited licence to access and use
                the website and content in accordance with these Terms of Use.
                AMX may terminate this licence at any time for any reason.
              </p>
              <p>2. Limitations on Use.</p>
              <p>
                The content on this website is for personal use only and (save
                as separately agreed in writing between you and AMX) not for
                commercial exploitation. You may use this website for your own
                personal use or your organisation’s internal use only (save as
                separately agreed in writing between you and AMX). You may not
                decompile, reverse-engineer, disassemble, rent, lease, loan,
                sell, sub-license or create derivative works from the website or
                the content. Nor may you use any network monitoring or discovery
                software to determine the website architecture, or extract
                information about usage or users. You may not use any robot,
                spider, or other automatic or manual device or process to
                monitor or copy the website or the content without AMX’s prior
                written permission. You may not print, download, copy, modify,
                reproduce, republish, distribute, display, or transmit for
                commercial, non-profit or public purposes all or any portion of
                the website, except to the extent permitted in these Terms of
                Use or as otherwise separately agreed in writing between you and
                AMX. You may not use or otherwise export or re-export the
                website or any portion thereof, the content or any software
                available on or through the website in violation of any export
                control laws and regulations. Any unauthorised use of the
                website or the content is prohibited.
              </p>
              <p>3. Your details and information.</p>
              <p>
                We will only use your personal information as set out in our
                Privacy and Cookies Policy.
              </p>
              <p>4. Not Professional Advice.</p>
              <p>
                The website and the content do not constitute on the part of AMX
                accounting, broking, consulting, investment, insurance, legal,
                tax or any other type of professional advice, and should be used
                only in conjunction with the services of appropriate
                professional advisors who have full knowledge of the user’s
                situation. The material on this website has been prepared for
                informational purposes only and does not constitute an offer, or
                a solicitation of an offer, to buy or sell any security or
                financial instrument, or to participate in any investment
                strategy. The accuracy, completeness, adequacy or currency of
                the website or the content is not warranted or guaranteed. The
                investment vehicles described herein may be construed as high
                risk and may experience substantial or sudden loss, including
                total loss of invested capital. Your use of the content, the
                website or materials linked from the website is at your own
                risk.
              </p>
              <p>5. Compliance with laws in your jurisdiction.</p>
              <p>
                Some products and services described in AMXConnect may not be
                available in all jurisdictions. The services and products
                described, and information provided through AMXConnect are not
                directed to and are not intended for distribution to, or use by,
                any person or entity in any jurisdiction:
              </p>
              <ul>
                <li>
                  Where such distribution or use would be contrary to law, rule
                  or regulation (“laws”), or that would subject AMX or any AMX
                  fund to any registration requirement within such jurisdiction;
                  or
                </li>
                <li>
                  Where AMX is not authorized to provide such information,
                  products or services.
                </li>
              </ul>
              <p>
                Persons who access this website are deemed to do so on their own
                initiative and are responsible for compliance with all
                applicable laws. Materials from this website may be subject to
                controls imposed by law, and may not be exported to any
                jurisdiction or to anyone prohibited by law. AMX expressly
                prohibits the downloading or exporting of material from this
                website in violation of the laws of any applicable jurisdiction.
                By downloading material from this website, you warrant that you
                are doing so in full compliance with the laws of the England and
                Wales and your resident jurisdiction, if different.
              </p>
              <p>6. Not an offer of securities.</p>
              <p>
                Under no circumstances should any material on this website be
                used or considered as an offer to sell, or a solicitation of an
                offer to buy, any interest in any investment fund sponsored or
                managed by AMX or its affiliates. Any such offer or solicitation
                can and will be made only by means of appropriate offering
                documents (Prospectus and Supplement) for each such investment
                fund, only in jurisdictions in which such an offer would be
                lawful and only to individuals who meet the investor suitability
                and sophistication requirements of each such investment fund.
                Access to information about the investment funds is similarly
                limited to individuals who meet the applicable investor
                suitability and sophistication requirements set forth in their
                respective resident jurisdictions.
              </p>
              <p>7. Intellectual Property Rights.</p>
              <p>
                All content, unless otherwise indicated, is protected by law
                including, but not limited to, copyright, trade secret, database
                rights, patent and trademark law, as well as other national and
                international laws and regulations. All intellectual property
                rights in the website and the content remain at all time the
                property of AMX and/or its licensors. Except as expressly
                provided in this Terms of Use or the website, AMX does not grant
                any express or implied rights to you under any patent,
                copyright, trademark, database right or trade secret information
                or other intellectual property right. Accordingly, any
                unauthorised use of the website or the content may violate
                copyright laws, trademark laws, database right laws, patent
                laws, trade secret laws, or laws relating to privacy and
                confidentiality.
              </p>
              <p>
                By submitting content to a forum or any other portion of the
                website, you automatically grant AMX and its other affiliate
                companies a royalty-free, perpetual, irrevocable, non-exclusive
                right and licence to use, reproduce, modify, adopt, publish,
                edit (for length or clarity), translate, create derivative works
                from, distribute, redistribute, transmit, perform and display
                such content (in whole or in part) worldwide and/or to
                incorporate it in other works in any form, media or technology
                now known or later developed for the full term of any rights
                that my exist in such content. AMX reserves the right to remove
                any content submitted to the website at any time for any reason.
              </p>
              <p>8. Website Content.</p>
              <p>
                You may print off one copy, and may download extracts, of any
                page(s) from the website for your personal use and you may draw
                the attention of others within your organisation to content
                posted on the website. You must not modify the paper or digital
                copies of any materials you have printed off or downloaded in
                any way, and you must not use any illustrations, photographs,
                video or audio sequences or any graphics separately from any
                accompanying text. AMX’s status (and that of any identified
                contributors) as the authors of content on the website must
                always be acknowledged. You must not use any part of the content
                on the website for commercial purposes without obtaining a
                licence to do so from AMX or our licensors. If you print off,
                copy or download any part of the website in breach of these
                terms of use, your right to use the website will cease
                immediately and you must, at AMX’s option, return or destroy any
                copies of the materials you have made.
              </p>
              <p>
                Upon registration, you will be given limited user access to only
                relevant materials that you are authorised to view. If you
                access or receive materials that you are not authorised to view,
                you should immediately delete all such materials and immediately
                inform AMX.
              </p>
              <p>9. Uploading content.</p>
              <p>
                Whenever you make use of a feature that allows you to upload
                content to the website (a “Contribution”), or to make contact
                with other users of the website, you must comply with the
                following content standards (the “Content Standards”):
              </p>
              <ul>
                <li>
                  A Contribution must:
                  <ul>
                    <li>Be accurate (where it states facts).</li>
                    <li>Be genuinely held (where it states opinions).</li>
                    <li>
                      Comply with the law applicable in England and Wales and in
                      any country from which it is posted.
                    </li>
                  </ul>
                </li>
                <li>
                  A Contribution must not:
                  <ul>
                    <li>Be defamatory of any person.</li>
                    <li>Be obscene, offensive, hateful or inflammatory.</li>
                    <li>Promote sexually explicit material.</li>
                    <li>Promote violence.</li>
                    <li>
                      Promote discrimination based on race, sex, religion,
                      nationality, disability, sexual orientation or age.
                    </li>
                    <li>
                      Infringe any copyright, database right or trademark of any
                      other person.
                    </li>
                    <li>Be likely to deceive any person.</li>
                    <li>
                      Breach any legal duty owed to a third party, such as a
                      contractual duty or a duty of confidence.
                    </li>
                    <li>Promote any illegal activity.</li>
                    <li>Be in contempt of court.</li>
                    <li>
                      Be threatening, abuse or invade another’s privacy, or
                      cause annoyance, inconvenience or needless anxiety.
                    </li>
                    <li>
                      Be likely to harass, upset, embarrass, alarm or annoy any
                      other person.
                    </li>
                    <li>
                      Impersonate any person, or misrepresent your identity or
                      affiliation with any person.
                    </li>
                    <li>
                      Give the impression that the Contribution emanates from
                      AMX, if this is not the case.
                    </li>
                    <li>
                      Advocate, promote, incite any party to commit, or assist
                      any unlawful or criminal act such as (by way of example
                      only) copyright infringement or computer misuse.
                    </li>
                    <li>
                      Contain a statement which you know or believe, or have
                      reasonable grounds for believing, that members of the
                      public to whom the statement is, or is to be, published
                      are likely to understand as a direct or indirect
                      encouragement or other inducement to the commission,
                      preparation or instigation of acts of terrorism.
                    </li>
                    <li>
                      Contain any advertising or promote any services or web
                      links to other sites.
                    </li>
                  </ul>
                </li>
              </ul>
              <p>
                You warrant that any such Contribution does comply with those
                Content Standards, and you will be liable AMX and indemnify AMX
                for any breach of that warranty. This means you will be
                responsible for any loss or damage AMX suffers as a result of
                your breach of warranty. Any content you upload to the website
                will be considered non-confidential and non-proprietary. You
                retain all of your ownership rights in your content, but you are
                required to grant us the rights to use, store and copy that
                content described in section 6 of these Terms of Use.
              </p>
              <p>
                AMX has the right to remove any Contribution you make on the
                website if, in AMX’s opinion, your Contribution does not comply
                with the Content Standards and/or these Terms of Use. You are
                solely responsible for securing and backing up your
                Contribution.
              </p>
              <p>10. Errors and Corrections.</p>
              <p>
                AMX does not represent or warrant that the website will be
                error-free, free of viruses or other harmful components, or that
                defects will be corrected. AMX does not warrant or represent
                that the content and any information available on or through the
                website will be correct, accurate, timely or otherwise reliable.
                AMX may make changes to the content or the website at any time.
              </p>
              <p>11. Third-Party content and services.</p>
              <p>
                The website may enable access to certain products and services
                provided by AMX and to certain websites, products and services
                provided by third parties (collectively and individually,
                “Services”). Use of certain Services may require you to accept
                additional terms and may be subject to additional fees.
              </p>
              <p>
                The website and certain Services may display, include or make
                available content, data, information, applications, products,
                services, materials or websites from third parties (“Third Party
                Content”). By using the website, you acknowledge and agree that
                AMX is not responsible for examining or evaluating the content,
                accuracy, completeness, timeliness, validity, copyright
                compliance, legality, decency, quality or any other aspect of
                such Third Party Content. AMX, its officers, affiliates and
                subsidiaries do not warrant or endorse and do not assume and
                will not have any liability or responsibility to you or any
                other person for any Third Party Content. Such Third Party
                Content, products or services and links to other web sites are
                provided solely as a convenience to you.
              </p>
              <p>12. DISCLAIMER.</p>
              <p>
                THE WEBSITE, THE CONTENT AND SERVICES ARE PROVIDED ON AN “AS-IS”
                BASIS. AMX EXPRESSLY DISCLAIMS ALL WARRANTIES, INCLUDING THE
                WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
                AND NON-INFRINGEMENT. AMX DISCLAIMS ALL RESPONSIBILITY FOR ANY
                LOSS, INJURY, CLAIM, LIABILITY OR DAMAGE OF ANY KIND RESULTING
                FROM, ARISING OUT OF OR ANY WAY RELATED TO: (A) ANY ERRORS IN OR
                OMISSIONS FROM THIS WEBSITE, CONTENT AND SERVICES, INCLUDING BUT
                NOT LIMITED TO TECHNICAL INACCURACIES AND TYPOGRAPHICAL ERRORS;
                (B) ANY THIRD-PARTY CONTENT THEREIN DIRECTLY OR INDIRECTLY
                ACCESSED THROUGH LINKS IN THIS WEBSITE, INCLUDING BUT NOT
                LIMITED TO ANY ERRORS IN OR OMISSIONS THEREFROM; (C) THE
                UNAVAILABILITY OF THE WEBSITE OR ANY PORTION THEREOF; (D) YOUR
                USE OF THIS WEBSITE, THE CONTENT AND SERVICES; OR (E) YOUR USE
                OF ANY EQUIPMENT OR SOFTWARE IN CONNECTION WITH THE WEBSITE, THE
                CONTENT OR SERVICES.
              </p>
              <p>
                YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT, TO THE EXTENT
                PERMITTED BY APPLICABLE LAW, USE OF THE WEBSITE AND ANY SERVICES
                PERFORMED BY OR ACCESSED THROUGH THE WEBSITE IS AT YOUR SOLE
                RISK AND THAT THE ENTIRE RISK AS TO SATISFACTORY QUALITY,
                PERFORMANCE, ACCURACY AND EFFORT IS WITH YOU.
              </p>
              <p>
                AMX DOES NOT WARRANT AGAINST INTERFERENCE WITH YOUR ENJOYMENT OF
                THE WEBSITE OR SERVICES, THAT THE FUNCTIONS CONTAINED IN, OR
                SERVICES PERFORMED OR PROVIDED BY, THE WEBSITE WILL MEET YOUR
                REQUIREMENTS, THAT THE OPERATION OF THE WEBSITE AND SERVICES
                WILL BE UNINTERRUPTED OR ERRORFREE, THAT ANY SERVICES WILL
                CONTINUE TO BE MADE AVAILABLE, THAT DEFECTS IN THE WEBSITE OR
                SERVICES WILL BE CORRECTED, OR THAT THE WEBSITE WILL BE
                COMPATIBLE OR WORK WITH ANY THIRD PARTY SOFTWARE, APPLICATIONS
                OR THIRD PARTY SERVICES.
              </p>
              <p>
                NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY AMX OR AN AMX
                AUTHORIZED REPRESENTATIVE SHALL CREATE A WARRANTY. SHOULD THE
                WEBSITE OR SERVICES PROVE DEFECTIVE, YOU ASSUME THE ENTIRE COST
                OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION. SOME
                JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES
                OR LIMITATIONS ON APPLICABLE STATUTORY RIGHTS OF A CONSUMER, SO
                THE ABOVE EXCLUSION AND LIMITATIONS MAY NOT APPLY TO YOU.
              </p>
              <p>13. LIMITATION OF LIABILITY.</p>
              <p>
                TO THE EXTENT NOT PROHIBITED BY APPLICABLE LAW, AMX SHALL NOT BE
                LIABLE FOR ANY LOSS, INJURY, CLAIM, LIABILITY OR DAMAGE OF ANY
                KIND RESULTING FROM YOUR USE OF THE WEBSITE, THE CONTENT OR THE
                SERVICES; AND AMX SHALL NOT BE LIABLE FOR ANY SPECIAL, DIRECT,
                INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES OF ANY KIND
                WHATSOEVER (INCLUDING, WITHOUT LIMITATION, ATTORNEYS’ FEES) IN
                ANY WAY DUE TO, RESULTING FROM OR ARISING IN CONNECTION WITH THE
                USE OF OR INABILITY TO USE THE WEBSITE, THE CONTENT OR THE
                SERVICES. TO THE EXTENT THE FOREGOING LIMITATION OF LIABILITY IS
                PROHIBITED, AMX’S SOLE OBLIGATION TO YOU FOR DAMAGES SHALL BE
                LIMITED TO ONE THOUSAND POUNDS STERLING (£1000).
              </p>
              <p>14. Unlawful Activity.</p>
              <p>
                AMX reserves the right to investigate complaints or reported
                violations of the Terms of Use and/or the Content Standards and
                to take any action we deem appropriate.
              </p>
              <p>15. Remedies for Violations.</p>
              <p>
                AMX reserves the right to seek all remedies available at law and
                in equity for violations of these Terms of Use, including but
                not limited to the right to block access from a particular
                Internet address to AMX’s websites and their features or to seek
                emergency or injunctive relief from the court to protect AMX’s
                proprietary rights or confidential information.
              </p>
              <p>
                You shall be liable to AMX and shall indemnify and hold harmless
                AMX against, all claims, demands, losses or damages (including
                costs and expenses arising therefrom or incidental thereto)
                which may be made against or suffered by AMX arising directly
                out of any breach of these Terms of Use including but not
                limited to your or the Company’s (or any of its employees',
                agents', sub-contractors', permitted delegates' or affiliates')
                fraud, negligence, wilful default, bad faith or, to the extent
                applicable, breach of its fiduciary duties under any applicable
                law.
              </p>
              <p>16. Registration.</p>
              <p>
                In order to use AMXConnect you are required to register. You
                agree to supply AMX with accurate and complete registration
                information. It is your responsibility to inform AMX of any
                changes to that information. You are responsible for maintaining
                the confidentiality of your username and/or password. You are
                responsible for all uses of your account, whether or not
                actually or expressly authorized by you. Notwithstanding the
                foregoing, you shall immediately notify AMX of any unauthorised
                use of the password or account or any breach of security. AMX
                reserves the right to refuse, cancel or suspend registrations in
                its sole discretion.
              </p>
              <p>17. Governing Law and Jurisdiction.</p>
              <p>
                These Terms of Use have been made in and shall be construed and
                enforced in accordance with the laws of England and Wales
                without regard to the conflict of law provisions thereof. Any
                action to enforce this agreement shall be brought only in the
                courts of England and Wales.
              </p>
              <p>18. Separate Agreements.</p>
              <p>
                AMX’s rights under these Terms of Use are without prejudice to
                any other contractual obligations, including the duty of
                confidentiality, found in any separate agreements with the user.
                Where any conflict arises, the terms of the separate agreement
                will prevail.
              </p>
              <p>19. Severability of Provisions.</p>
              <p>
                These Terms of Use incorporate by reference any notices
                contained on the website and the Privacy and Cookies Policy and
                the Important Notice. Subject to section 18, such terms together
                constitute the entire agreement between you and AMX with respect
                to access to, and use of, the website. Subject to section 18, if
                any provision of these Terms of Use is unlawful, void or
                unenforceable, or conflicts with any other provision of the
                Terms of Use, then the unlawful, void, unenforceable or
                conflicting provision shall be deemed severable from the
                remaining provisions and shall not affect their validity and
                enforceability.
              </p>
              <p>20. Modifications to Terms of Use.</p>
              <p>
                AMX reserves the right to change these Terms of Use at any time.
                Updated versions of the Terms of Use will appear on this website
                and are effective immediately. You are responsible for regularly
                reviewing the Terms of Use. Continued use of the website after
                any such changes constitutes your acceptance of such changes.
              </p>
              <p>21. No Partnership, Agency etc.</p>
              <p>
                Nothing in these Terms of Use shall create, or be deemed to
                create, a partnership or the relationship of principal and agent
                or employer and employee between the parties hereto.
              </p>
              <p>22. Waiver.</p>
              <p>
                A failure to exercise or delay in exercising a right or remedy
                provided by these Terms of Use or by law does not constitute a
                waiver of the right or remedy or a waiver of other rights or
                remedies. No single or partial exercise of a right or remedy
                provided by these Terms of Use or by law prevents further
                exercise of that right or remedy or the exercise of another
                right or remedy.
              </p>
              <p>23. Electronic Execution.</p>
              <p>
                The parties agree that the execution of these Terms of Use may
                be done electronically, including by way of clicking on a button
                or link on AMXConnect or through email communications.
              </p>
              <p>
                Except as expressly set out herein, no part of this website may
                be reproduced or transmitted in any form or by any means,
                electronic or mechanical, which includes but is not limited to
                facsimile transmission, photocopying, recording, rekeying or
                using any information storage or retrieval system, without
                express written permission from the copyright owner. Requests
                for permission or further information should be directed to the
                Webmaster.
              </p>
              <p>24. Performance</p>
              <p>
                Where AMXConnect displays information on the past performance of
                an investment product, such past performance is not a reliable
                indicator of future returns. Values may go down as well as up.
                Securities trading in which the fund engages can be speculative
                and involve a substantial risk of loss.
              </p>

              <h2 id="disclaimer-section-b">SECTION B. AMX FUNDS</h2>

              <p>
                The provisions set out in this Section are relevant to
                AMXConnect users who invest in investment funds in respect of
                which Carne Global Fund Managers (Ireland) Limited The Asset
                Management Exchange (Ireland) Limited acts as the management
                company.
              </p>
              <p>1. FX</p>
              <p>
                Currency exchange rates are sourced from Northern Trust
                International Fund Administration Services (Ireland). The data
                is based on indicative rates contributed by market participants
                and is NOT based on actual market trades. Where this data is not
                available, a generic rate will be used for conversions.
                Specifically, the WM Reuters rate file provided by Northern
                Trust will be applied.
              </p>
              <p>
                All currency exchange rates are sourced from Northern Trust
                International Fund Administration Services (Ireland). Rates are
                provided for informational purposes only and are subject to
                change without notice. All data is provided for informational
                purposes only and not intended for trading purposes; AMX does
                not guarantee the accuracy of the data. You should always
                confirm current exchange rates with a reputable foreign exchange
                broker before making any transactions.
              </p>
              <p>2. Pending flows</p>
              <p>
                The projected flows in and out of the relevant AMX master
                sub-fund (the “Master Fund”) displayed on this page (the
                “Estimated Projected Flows”) are estimates only and are based on
                information that AMX has received from the administrator in
                respect of the Master Fund, being Northern Trust International
                Fund Administration Services (Ireland) Limited. The Estimated
                Projected Flows speak only as of the date displayed on this page
                and are forward-looking statements based upon the reasonable
                belief of AMX and are not a guarantee of future flows in or out
                of the Master Fund. AMX assumes no duty to and does not
                undertake to update the Estimated Projected Flows; the Estimated
                Projected Flows are subject to change without notice. Actual
                future flows in or out of the Master Fund may differ materially
                from the Estimated Projected Flows. AMX does not warrant to the
                accuracy or completeness of the Estimated Project Flows. The
                Estimated Projected Flows should not be exclusively relied upon
                in the context of making investment decisions on behalf of the
                Master Fund, however, you, as the sub-investment manager in
                respect of the Master Fund, should have regard to the Estimated
                Projected Flows when placing or effecting a trade on behalf of
                the Master Fund, as set out in the sub-investment management
                agreement in respect of the Master Fund. AMX accepts no
                responsibility for any loss (whether direct, indirect, special,
                incidental, punitive or consequential loss, including loss of
                profits) which may directly or indirectly arise from reliance on
                the Estimate Project Flows.
              </p>
              <p>3. Implied holdings</p>
              <p>
                The information or data displayed on this page is to provide
                investors with an indication of the types of assets that are
                held within a particular AMX master sub-fund, being the sub-fund
                in which the corresponding AMX feeder sub-fund will invest
                (“Implied Holdings Data”). Investors in an AMX feeder sub-fund
                only hold shares in that AMX feeder sub-fund and do not hold any
                of the underlying assets that sit within the relevant AMX master
                sub-fund.
              </p>
              <p>
                The Implied Holdings Data displayed on this page may not
                accurately reflect all of the types of assets that are held
                within the relevant AMX master sub-fund; the Implied Holdings
                Data is intended for indicative and illustrative purposes only.
                Whilst the Implied Holdings Data has been prepared in good faith
                and AMX has endeavoured to ensure that the Implied Holdings Data
                is accurate and complete as of the date displayed on this page,
                AMX does not warrant as to the accuracy or completeness of the
                Implied Holdings Data. AMX assumes no duty to and does not
                undertake to update the Implied Holdings Data; the Implied
                Holdings Data is subject to change without notice. The actual
                asset composition of the relevant AMX master sub-fund may differ
                materially from the Implied Holdings Data displayed on this
                page. The Implied Holdings Data does not constitute investment
                advice and should not be construed as a recommendation to invest
                in, or redeem from, the relevant AMX feeder sub-fund; the
                Implied Holdings Data should not be relied upon in the context
                of making an investment decision or otherwise. AMX accepts no
                responsibility for any loss (whether direct, indirect, special,
                incidental, punitive or consequential loss, including loss of
                profits), which may directly or indirectly arise from reliance
                on the Implied Holdings Data.
              </p>
              <p>4. Latest available data</p>
              <p>
                The data displayed on this page comprises estimated net asset
                values of a particular series of shares within the relevant AMX
                feeder sub-fund (“NAVs”) and prior official NAVs, as at the
                dates displayed on this page. Investors will not be able to
                subscribe for, or redeem, shares within the relevant AMX feeder
                sub-fund based on prior official NAVs or estimated NAVs and
                subscriptions and redemptions may only be made solely on the
                basis of the official NAV calculated for the relevant dealing
                day as detailed in the relevant AMX offering documentation.
              </p>
              <p>
                In considering any investment performance information contained
                within AMXConnect, users of AMXConnect should bear in mind that
                past performance is not necessarily indicative of future results
                and there can be no guarantee that the relevant AMX sub-fund
                will achieve comparable results, that targeted returns,
                diversification or asset allocations will be met or that the
                relevant AMX sub-fund will be able to implement its investment
                strategy or achieve its investment objectives. Any information
                regarding prior investment activities and returns contained in
                AMXConnect may not have been calculated using generally accepted
                accounting principles and have not been audited or verified by
                the AMX auditors or any independent party. AMX may report
                estimated weekly and month end valuations which are subject to
                change and final checks by the Fund Administrator. Investors
                should always refer to official investor statements for final
                valuations.
              </p>
              <p>
                To the extent AMXConnect displays track record information
                regarding the past performance of a particular AMX sub-fund,
                such information is not comprehensive and potential investors
                should not consider such information to be indicative of the
                possible future performance of the relevant AMX sub-fund or any
                investment opportunity to which the information contained in
                AMXConnect relates.
              </p>
              <p>5. Eligible users</p>
              <p>
                Information relating to AMX funds is only made available to
                investment professionals only who are or would be classified as
                (1) Professional Clients under the applicable FCA rules and who,
                if they are US residents or citizens, are or would be qualified
                as “Qualified Purchasers” under the US Investment Company Act
                1940 and “Qualified Eligible Persons” under the US Commodity
                Futures Trading Commission regulations, and is specifically not
                intended for any other persons including persons who are or
                would be classified as Retail Clients under applicable FCA
                rules, or (2) current and potential investment managers of AMX
                funds.
              </p>

              <h2 id="disclaimer-section-c">SECTION C: AMXCONNECT STORE</h2>

              <p>1. Third Party Services</p>
              <p>
                AMX allows third party sellers to list and sell their product or
                services (together “Third Party Services”) on AMXConnect through
                the Store. This Section C applies to any user who buys, licenses
                or otherwise accesses Third Party Services through AMXConnect’s
                Store.
              </p>
              <p>
                While AMX as a service provider helps facilitate transactions
                that are carried out on the AMXConnect Store, AMX is neither the
                buyer nor the seller of Third Party Services. AMX provides a
                service for sellers and buyers to negotiate and complete
                transactions. Accordingly, the contract formed at the completion
                of a sale of these Third Party Services is solely between buyer
                and seller. AMX is not a party to this contract and does not
                assume any responsibility arising out of or in connection with
                it nor is it the seller's agent. The seller is responsible for
                the sale of the products and for dealing with any buyer claims
                or any other issue arising out of or in connection with the
                contract between the buyer and seller. In particular (but
                without limitation) unless otherwise explicitly stated AMX has
                not carried out a cyber security or similar risk assessment on
                the sellers of Third Party Services.
              </p>
              <p>
                AMXConnect includes information on Third Party Services provided
                by sellers that have signed a non-binding letter of intent as
                well as contractually committed sellers.
              </p>
              <p>
                Note that certain conflicts of interest may arise in connection
                with Third Party Services including in connection with (i) the
                providers of Third Party Services being contracted to provide
                such services to AMX or the investment funds in respect of which
                Carne Global Fund Managers (Ireland) Limited The Asset Management 
                Exchange (Ireland) Limited acts as the
                management company or (ii) personal investments made by AMX
                personnel.
              </p>
              <p>2. Rebates</p>
              <p>
                In certain cases, AMX may offer (on an ex gratia, non binding
                basis) to pay rebates to a user who purchases Third Party
                Services via the AMXConnect Store.
              </p>
              <p>
                When a user clicks through to or otherwise makes contact with a
                Service Provider advertised on the Store, AMX is in effect
                acting as an advertising agent for the Service Provider by
                sending it customers. In return for this, the Service Provider
                pays AMX a commission. It is this commission that AMX uses to
                make a cash payment (“Rebate”) to the user.
              </p>
              <p>
                Any such Rebate offer is subject to the following terms (in
                addition to those set out elsewhere in the Terms of Use):
              </p>

              <ul>
                <li>
                  The amount of the Rebate is set at AMX’s discretion and will
                  vary between Service Providers and their different products
                  and may vary over time.
                </li>
                <li>
                  It is at the entire discretion of AMX and the Service Provider
                  to determine whether a transaction for the purchase of Third
                  Party Services is genuine and the Service Provider must
                  confirm the purchase and the amount of the transaction. Rebate
                  may be declined if all or part of an order is returned,
                  amended or cancelled.
                </li>
                <li>
                  Rebate is only available to buyers who are not already clients
                  of the relevant Service Provider.
                </li>
                <li>
                  Rebate only applies to the first purchase of a particular
                  product from a Service Provider and not to subsequent
                  purchases.
                </li>
                <li>
                  AMX’s ability to pay Rebate is subject to AMX’s receipt of its
                  commission from the relevant Service Provider which in turn is
                  dependent on the Service Provider’s determination that a
                  commission is payable to AMX.{" "}
                </li>
                <li>
                  AMX’s decision is final in relation to paying Rebate to users.
                  AMX will make reasonable endeavours to secure the payment of
                  commission on a transaction but we do not and cannot make any
                  guarantee in this regard. In the event we do not receive the
                  expected commission for a transaction for whatever reason, we
                  will not be liable to pay the relevant Rebate to the user.
                </li>
                <li>
                  AMX does not act as a bank and do not hold Rebate on behalf of
                  users. Legal title to any Rebate earnings does not pass to a
                  user until the user has taken possession of the Rebate by way
                  of a successful receipt of the Rebate into the user’s bank
                  account.
                </li>
                <li>
                  Rebates will only be made into business (and not personal)
                  bank accounts and only once the recipient has satisfied all of
                  AMX’s identity and authority validation requirements. It is
                  the responsibility of the user to ensure that payment of
                  Rebate reaches the user by supplying correct bank account
                  details and keeping those updated as necessary from time to
                  time.
                </li>
                <li>
                  AMX will not transfer Rebate where it would be illegal to do
                  so, or otherwise put AMX or any Service Provider in breach of
                  the law.
                </li>
                <li>
                  Users give their explicit consent for the Service Providers to
                  share details with AMX about users’ purchases in order to
                  facilitate the arrangements envisaged by these Terms of Use.
                </li>
                <li>
                  In all circumstances the payment of Rebate to users is at
                  AMX’s discretion and AMX may refuse to pay Rebate to a user
                  for any reason.
                </li>
                <li>
                  Following receipt of the user’s Rebate payment, the user will
                  be responsible for the payment of any taxes including (but not
                  being limited to) VAT that fall due and it is the user’s
                  responsibility to ensure that these are paid in full. AMX will
                  not in any way be liable for your failure to do so.
                </li>
                <li>
                  AMX reserves the right to reclaim or adjust any Rebate
                  payments in the event that any Rebate has been paid to a user
                  in error.
                </li>
                <li>
                  AMX has the right to impose a de-minimis limit on the amount
                  of Rebate that it will pay.
                </li>
                <li>
                  AMX has the right to determine the appropriate currency in
                  which Rebate payments will be made.
                </li>
              </ul>

              <p className={classes.smallPrint}>
                Copyright © The Asset Management Exchange (UK) Limited. All
                rights reserved.
              </p>
            </Grid>
          </Grid>
          <Button onClick={handleOnAccept} className={classes.button}>
            ACCEPT
          </Button>
          <Grid container>
            <p className={classes.footerText}>
              By clicking "ACCEPT" you agree to these Disclaimers, the Terms &
              Conditions and the{" "}
              <Link
                href="https://theamx.com/privacy-and-cookies/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Privacy Policy
              </Link>
            </p>
          </Grid>
        </Paper>
      </Fade>
    </Modal>
  );
};

Disclaimer.storageKey = "disclaimer";

Disclaimer.propTypes = {
  /** Disabled prop controlling the modal */
  disabled: PropTypes.bool,
  /** Callback function called when this is closed. */
  onClosed: PropTypes.func,
};
